'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _handleBeforeInput = require('./handleBeforeInput');

var _handleBeforeInput2 = _interopRequireDefault(_handleBeforeInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return {
        handleBeforeInput: _handleBeforeInput2.default
    };
}; // Utils


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/markdownSupport/index.js
// module id = 1736
// module chunks = 0